import { connect } from 'react-redux';
import { logger } from '@fiverr-private/obs';
import { reportWorkSampleFilterEvent, TYPES } from '../../../../utils/reports/filter/workSampleFilter';
import { toggleWorkSample } from '../../../../store/actions';
import WorkSample from './WorkSample';

const mapStateToProps = ({ filters_counters, workSampleChecked }) => {
    const filtersCounters = filters_counters || {};

    return {
        workSampleChecked,
        filterCount: filtersCounters.work_sample,
    };
};

const mapDispatchToProps = (dispatch) => ({
    onToggle: (value) => {
        const checked = value.target.checked;
        dispatch(toggleWorkSample(checked))
            .then((eventData) => {
                const type = checked ? TYPES.workSample.onClick : TYPES.workSample.offClick;

                reportWorkSampleFilterEvent(type, { ...eventData });
            })
            .catch((error) => {
                logger.error(error, {
                    func: 'onToggle',
                    component: 'WorkSample',
                });
            });
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(WorkSample);
